/**
 * TrustBadges Component
 * Displays security and trust signals on checkout page
 * Improves user confidence during payment submission
 */

export function TrustBadges() {
  return (
    <div className="bg-gray-50 rounded-lg p-4 border border-gray-200 mt-4">
      <div className="flex items-center justify-center gap-4 flex-wrap">
        {/* SSL Badge */}
        <div className="flex items-center text-sm text-gray-700">
          <svg
            className="w-5 h-5 text-green-600 mr-1.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M5 9V7a5 5 0 0110 0v2a2 2 0 012 2v5a2 2 0 01-2 2H5a2 2 0 01-2-2v-5a2 2 0 012-2zm8-2v2H7V7a3 3 0 016 0z"
              clipRule="evenodd"
            />
          </svg>
          <span className="font-medium">Secure SSL Encryption</span>
        </div>

        {/* Stripe Badge */}
        <div className="flex items-center text-sm text-gray-700">
          <svg
            className="w-5 h-5 text-blue-600 mr-1.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z"
              clipRule="evenodd"
            />
          </svg>
          <span className="font-medium">Powered by Stripe</span>
        </div>

        {/* Privacy Badge */}
        <div className="flex items-center text-sm text-gray-700">
          <svg
            className="w-5 h-5 text-gray-600 mr-1.5 flex-shrink-0"
            fill="currentColor"
            viewBox="0 0 20 20"
            aria-hidden="true"
          >
            <path d="M10 2a5 5 0 00-5 5v2a2 2 0 00-2 2v5a2 2 0 002 2h10a2 2 0 002-2v-5a2 2 0 00-2-2H7V7a3 3 0 015.905-.75 1 1 0 001.937-.5A5.002 5.002 0 0010 2z" />
          </svg>
          <span className="font-medium">We never store card details</span>
        </div>
      </div>

      <p className="text-xs text-gray-500 text-center mt-2">
        Your payment information is encrypted and secure
      </p>
    </div>
  );
}
